import { gql } from '@apollo/client';

import { useQuery } from 'platform/apollo';

import { GetMarket, GetMarketVariables } from 'buying/graphql/__generated__/GetMarket';
import { MarketData, MarketDataVariables } from 'buying/graphql/__generated__/MarketData';

export const marketDataQuery = gql`
  query MarketData($addressUUID: String!) {
    casa {
      find(input: { uuid: $addressUUID }) {
        address {
          marketData {
            buy_with_opendoor_enabled
          }
        }
      }
    }
  }
`;

/**
 * Get market data for a given address
 */
export const useMarketData = (addressUUID?: string | null) => {
  const { data, ...rest } = useQuery<MarketData, MarketDataVariables>(marketDataQuery, {
    variables: {
      // @ts-expect-error -- variable is possibly undefined/null
      addressUUID,
    },
    skip: !addressUUID,
    context: { linkContext: { team: 'marketplace' } },
  });

  return {
    ...rest,
    inBwODMarket: !!data?.casa?.find?.address?.marketData?.buy_with_opendoor_enabled,
  };
};

const getMarketQuery = gql`
  query GetMarket($input: OdProtosWebServicesWebMarket_GetMarketRequestInput!) {
    webMarket {
      getMarket(input: $input) {
        market {
          marketData {
            mapCenterLatitude
            mapCenterLongitude
          }
        }
      }
    }
  }
`;

/** Get market data based on identifier */
export const useGetMarket = (identifier: string) => {
  const { data, ...rest } = useQuery<GetMarket, GetMarketVariables>(getMarketQuery, {
    variables: {
      input: { identifier },
    },
    skip: !identifier,
    context: { linkContext: { team: 'marketplace' } },
  });

  return {
    ...rest,
    mapCenterLatitude: data?.webMarket?.getMarket?.market?.marketData?.mapCenterLatitude,
    mapCenterLongitude: data?.webMarket?.getMarket?.market?.marketData?.mapCenterLongitude,
  };
};
